export enum HeaderContentTypeEnum {
    HEADER_CONTENT_0 = 'HEADER_CONTENT_0',
    HEADER_CONTENT_1 = 'HEADER_CONTENT_1',
}
